<input class="cell-editor-input"
       type="number"
       [(ngModel)]="value" />